import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import HealthcareProcessFlow from "./HealthcareProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  HEALTHCARE_DOMAIN_INTRO,
  HEALTHCARE_GROUPS,
  HEALTHCARE_USE_CASES_SEO,
  HEALTHCARE_DOMAIN_FAQS,
  HEALTHCARE_ITEM_LIST_JSONLD,
  HEALTHCARE_BREADCRUMB_JSONLD,
  HEALTHCARE_WEBPAGE_JSONLD,
  HEALTHCARE_FAQ_JSONLD,
} from "../../data/healthcareUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<HealthcareProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = HEALTHCARE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;

  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function HealthcareDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");

  const visibleGroups =
    activeFilter === "all"
      ? HEALTHCARE_GROUPS
      : HEALTHCARE_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={HEALTHCARE_DOMAIN_INTRO}
        domainSlug="healthcare-domain"
        useCaseCount={HEALTHCARE_USE_CASES_SEO.length}
        groupCount={HEALTHCARE_GROUPS.length}
        itemListJsonLd={HEALTHCARE_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={HEALTHCARE_BREADCRUMB_JSONLD}
        faqJsonLd={HEALTHCARE_FAQ_JSONLD}
        webPageJsonLd={HEALTHCARE_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>

      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{HEALTHCARE_DOMAIN_INTRO.title}</h1>
          {HEALTHCARE_DOMAIN_INTRO.content ? (
            <p>{HEALTHCARE_DOMAIN_INTRO.content}</p>
          ) : null}
        </div>
      </header>

      <UseCaseIndexGrid
        useCases={HEALTHCARE_USE_CASES_SEO}
        groups={HEALTHCARE_GROUPS}
        heading="Healthcare Use Cases"
        onFilterChange={setActiveFilter}
      />

      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={HEALTHCARE_DOMAIN_INTRO.title}
        domainFaqs={HEALTHCARE_DOMAIN_FAQS}
        useCases={HEALTHCARE_USE_CASES_SEO}
      />
    </div>
  );
}

